<template>
	<section>
		<template v-if="windowWidth >= mobileBreakpoint">
			<form class="content-main" autocomplete="off">
				<input type="hidden" autocomplete="false" />
				<fast-payment />
				<payout />
				<accounts />
				<mifid-panel />
			</form>
		</template>
		<template v-else>
			<form class="content-main-mobile mb-3" autocomplete="off">
				<input type="hidden" autocomplete="false" />
				<swiper
					:pagination="pagination"
					:modules="modules"
					:autoHeight="true"
					:observer="true"
					:observeParents="true"
					ref="DashboardSwiper"
					id="DashboardSwiper"
				>
					<swiper-slide>
						<accounts-mobile />
					</swiper-slide>
					<swiper-slide>
						<fast-payment-mobile />
					</swiper-slide>
					<swiper-slide>
						<payout-mobile />
					</swiper-slide>
				</swiper>
				<div class="swiper-pagination" slot="pagination"></div>
			</form>
			<div></div>
			<mifid-panel />
		</template>
		<div class="content-side">
			<app-mnews />
			<!-- <app-mnews-banner /> -->
			<app-training />
		</div>
	</section>
</template>

<script>
import AppMnews from '@/components/AppMnews';
// import AppMnewsBanner from '@/components/AppMnewsBanner';
import AppTraining from '@/components/AppTraining';
import FastPayment from '@/views/dashboard/partial/_FastPayment';
import Payout from '@/views/dashboard/partial/_Payout';
import Accounts from '@/views/dashboard/partial/_Accounts';

import FastPaymentMobile from '@/views/dashboard/partial/_FastPaymentMobile';
import PayoutMobile from '@/views/dashboard/partial/_PayoutMobile';
import AccountsMobile from '@/views/dashboard/partial/_AccountsMobile';

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Scrollbar } from 'swiper/modules';
import 'swiper/css';
// import 'swiper/css/pagination';

import { mapGetters } from 'vuex';
import MifidPanel from '@/views/dashboard/partial/_MifidPanel';

export default {
	data() {
		return {
			modules: [Pagination, Scrollbar],
			pagination: {
				clickable: true,
			},
		};
	},
	components: {
		AppMnews,
		AppTraining,
		FastPayment,
		Payout,
		Accounts,
		FastPaymentMobile,
		PayoutMobile,
		AccountsMobile,
		// AppMnewsBanner,
		MifidPanel,
		Swiper,
		SwiperSlide,
	},
	methods: {
		onPageChange(e) {
			this.$store.commit('setActiveMobileNavIcon', e);
		},
		closeDocumentExpired() {
			this.$store.commit('setDocumentExpired', false);
		},
		closeConfirmModal() {
			this.$store.commit('setShowModalPayoutSuccess', false);
		},
	},
	computed: {
		user() {
			return this.$store.getters.getUser
				? this.$store.getters.getUser
				: false;
		},
		windowWidth() {
			return this.$store.getters.getWindowWidth;
		},
		activeSlide() {
			return this.$store.getters.getActiveSlide;
		},
		expired() {
			return this.$store.getters.getDocumentExpired
				? this.$store.getters.getDocumentExpired
				: false;
		},
		showConfirmModal() {
			return this.$store.getters.getShowModalPayoutSuccess;
		},
		...mapGetters({
			mobileBreakpoint: 'getMobileBreakpoing',
		}),
		...mapGetters(['getQuizTypeModal', 'getShowQuizModal']),
		mobileMenu() {
			return this.$store.getters.getShowMobileMenu;
		},
	},
	mounted() {
		this.$store.dispatch(
			'fetchLogOutTimer',
			this.$store.getters.getTimeToLogout
		);

		window.addEventListener('pageshow', (event) => {
			if (event.persisted) {
				this.$store.commit('setPaymentLoadingButton', false);
			}
		});
	},
};
</script>
